import { Field, FieldProps, useFormikContext } from 'formik';
import { ButtonSwitch } from 'lib/components';
import React from 'react';
import styled from 'styled-components/macro';
import { Gap } from 'lib/components/styles/layout';
import { HiClock } from 'react-icons/hi';
import { UserValues } from '../userValidator';
import { useMaskito } from '@maskito/react';
import { ElementState } from '@maskito/core/src/lib/types';

const COLON = ':';
const timeMask = (value: string) => {
  const chars = value.split('');
  let hours = [];
  if (chars[0] === '0' || chars[0] === '1') {
    if (chars[1] === COLON) {
      hours = [/[0-1]/];
    } else {
      hours = [/[0-1]/, chars[0] === '1' ? /[0-2]/ : /[0-9]/];
    }
  } else {
    hours = [/[2-9]/];
  }

  const minutes = [/[0-5]/, /[0-9]/];

  return [...hours, ':', ...minutes] as RegExp[];
};

const timePipe = (conformedValue: string) => {
  if (!!conformedValue && !!conformedValue.length) {
    const parts = conformedValue.split(COLON);
    if (!!parts && !!parts.length) {
      const hour = parts[0];
      if (hour.length === 1 && (parts.length === 2 || parseInt(hour, 10) > 1)) {
        parts[0] = `0${hour}`;
      }

      return parts.join(COLON);
    }
  }
  return conformedValue;
};

const MaskedInputStyles = styled.input<{ error?: string }>`
  background: #ffffff;
  border: 1px solid
    ${({ error, theme }) =>
      !!error ? theme.colors.danger[100] : theme.colors.neutral[40]};
  border-radius: 4px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  padding: 8px 8px 8px 40px;
  color: ${props => props.theme.colors.neutral[100]};
  width: 46px;
`;

const InputWrapper = styled.div`
  position: relative;
`;

interface IMeridiemPicker {
  hoursName: string;
  defaultMeridiemValue: string;
  meridiemValue: string;
  isError?: boolean;
}

export const MeridiemPicker = ({
  hoursName,
  defaultMeridiemValue,
  meridiemValue,
  isError,
}: IMeridiemPicker) => {
  const { setFieldValue } = useFormikContext<UserValues>();

  const hourFormatMask = {
    mask: (elementState: ElementState) => timeMask(elementState.value),
  };
  const inputRef = useMaskito({ options: hourFormatMask });

  return (
    <Gap gap='4px'>
      <Field name={hoursName}>
        {({ field }: FieldProps) => {
          return (
            <InputWrapper>
              <HiClock
                style={{ position: 'absolute', left: 10, top: 10 }}
                size='20'
                color='rgba(146, 151, 162, 1)'
              />
              <MaskedInputStyles
                {...field}
                ref={inputRef}
                placeholder='00:00'
                error={isError ? 'error' : ''}
                onChange={event => {
                  const valueWithZero = timePipe(event.target.value);
                  setFieldValue(hoursName, valueWithZero);
                }}
              />
            </InputWrapper>
          );
        }}
      </Field>

      <ButtonSwitch
        className='btn-switch'
        defaultValue={defaultMeridiemValue}
        onChange={value => setFieldValue(meridiemValue, `${value}`)}
        values={[
          { value: 'AM', text: 'AM' },
          { value: 'PM', text: 'PM' },
        ]}
      />
    </Gap>
  );
};
